export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/GetFeatureInfo/GPactivateGfi.png?30e4fe092762568c11b2172f1ff3eb01";